import * as ActiveStorage from "@rails/activestorage";
import "bootstrap-icons/font/bootstrap-icons.css";
import * as Turbo from "@hotwired/turbo";
import Rails from "@rails/ujs";
import "@hotwired/turbo-rails";
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;
import "channels";
import "animate.css";
import "chartkick/chart.js";
import "./application.scss";
import "../stimulus/index";
import initializeDataTables from '../javascript/datatable';
import '../javascript/datatable_config';
import { startChartkickTurboLifecycle } from '../javascript/chartkick_turbo_lifecycle';
// LRPO-5180 — side-effect import: defines window.reportsDayTooltipTitle and
// window.reportsWireDayTooltip so the Reports Hub day charts' inline drilldown
// <script>s can wire a Chart.js tooltip-title callback that maps year-less
// "Jun 17" labels to real-year full dates. Mirrors how window.leadDrill
// (../lead_drill) reaches those scripts.
import '../javascript/reports_day_tooltip';
// LRPO-5314 — side-effect import: defines window.reportsCropTickLabel so the
// Demographics tab's inline drilldown <script> can crop a Chart.js category
// axis label to full-or-ellipsis (never overlapping the bars). Mirrors the
// window.leadDrill / window.reportsDayTooltipTitle bridge pattern above.
import '../javascript/chart_axis_label_crop';
// LRPO-5314 — side-effect import: defines window.reportsApplyDemographicsChartHeight
// so the same inline <script> can scale each Demographics chart's height to its
// category count (the bar count is only known once the remote JSON resolves, so
// the ERB's static height: '320px' squeezes a many-category chart to nothing).
import '../javascript/demographics_chart_height';
// LRPO-5507 — side-effect import: defines window.leadsSwapFilterChips and
// window.leadsUpdateFilterCount so the leads grid's inline DataTables dataSrc
// callback (_table.html.erb) can swap the chip-strip region and write the
// filter count. Same window bridge as window.leadDrill above.
import '../javascript/leads_filter_chips';
import $ from "jquery";
import 'select2';
import 'select2/dist/css/select2.css';
import "chartkick"
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import annotationPlugin from 'chartjs-plugin-annotation';
import { MatrixController, MatrixElement } from 'chartjs-chart-matrix';

Chart.register(ChartDataLabels, annotationPlugin, MatrixController, MatrixElement);
Chart.defaults.plugins.datalabels = { display: false };
Chart.defaults.font.family = "'Inter', system-ui, -apple-system, sans-serif";
Chart.defaults.font.size = 12;
Chart.defaults.color = '#545868';
Chart.defaults.plugins.tooltip.backgroundColor = '#1B1D26';
Chart.defaults.plugins.tooltip.titleFont = { family: "'Inter', sans-serif", size: 13, weight: '600' };
Chart.defaults.plugins.tooltip.bodyFont = { family: "'Inter', sans-serif", size: 12 };
Chart.defaults.plugins.tooltip.padding = { top: 10, right: 14, bottom: 10, left: 14 };
Chart.defaults.plugins.tooltip.cornerRadius = 6;
Chart.defaults.plugins.tooltip.displayColors = true;
Chart.defaults.plugins.tooltip.boxWidth = 8;
Chart.defaults.plugins.tooltip.boxHeight = 8;
Chart.defaults.scale.grid.color = 'rgba(0, 0, 0, 0.06)';

// LRPO-5928 — show a pointer cursor when hovering over any clickable chart
// element (bar, point, segment) on the Reports Hub. The onHover callback is
// applied to every chart, but scoped to canvases inside .reports-page so other
// dashboard charts are not affected. The canvas is reset to the default arrow
// cursor when no chart element is under the pointer.
Chart.defaults.onHover = (event, elements, chart) => {
  if (!chart?.canvas?.closest('.reports-page')) return;
  if (event?.native?.target) {
    event.native.target.style.cursor = elements.length > 0 ? 'pointer' : 'default';
  }
};

import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
window.$ = $;
window.jQuery = $;
import 'selectize';
import 'selectize/dist/css/selectize.default.css';
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
global.$ = global.jQuery = $;
import "datatables.net";
import "datatables.net-buttons";

Rails.start();
Turbo.start();
ActiveStorage.start();

// Phase 5 T28 — Bootstrap tooltip/popover lifecycle hooked into Turbo
// (fixes Phase 4 too). The original DOMContentLoaded-only init missed
// elements rendered into the page after a Turbo Drive navigation OR a
// Turbo Frame swap, so popovers on dashboard / report pages stopped
// firing once the user navigated within the SPA. Init runs on:
//   * DOMContentLoaded (cold load + page refresh)
//   * turbo:load          (every Turbo Drive page render)
//   * turbo:frame-render  (every Turbo Frame swap — partials,
//                          recipient picker results, ROI Stream)
// before-cache disposes existing instances [Frontend S3] so a cached
// page restore doesn't try to re-attach popover backdrops to nodes
// that no longer exist.
function initBootstrapInteractives() {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    if (!bootstrap.Tooltip.getInstance(el)) {
      new bootstrap.Tooltip(el, { trigger: 'focus hover' });
    }
  });
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => {
    if (!bootstrap.Popover.getInstance(el)) {
      new bootstrap.Popover(el, { trigger: 'focus hover' });
    }
  });
}

function disposeBootstrapInteractives() {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    bootstrap.Tooltip.getInstance(el)?.dispose();
  });
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => {
    bootstrap.Popover.getInstance(el)?.dispose();
  });
  // LRPO-5840 — Modals and Offcanvases were never torn down here, so a Turbo
  // navigation left instances bound to nodes the swap had replaced. Their
  // listeners still fire, and every one of them reads `this._config`, which is
  // null on a disposed instance:
  //   TypeError: undefined is not an object (evaluating 'this._config.backdrop')
  //
  // ⚠ Select on `.modal` / `.offcanvas`, NOT on [data-bs-toggle] like the two
  // loops above. The toggle attribute is on the BUTTON; the instance is bound to
  // the panel.
  document.querySelectorAll('.modal').forEach((el) => {
    bootstrap.Modal.getInstance(el)?.dispose();
  });
  document.querySelectorAll('.offcanvas').forEach((el) => {
    bootstrap.Offcanvas.getInstance(el)?.dispose();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initBootstrapInteractives();
  initializeDataTables();
});
document.addEventListener('turbo:load', initBootstrapInteractives);
document.addEventListener('turbo:frame-render', initBootstrapInteractives);
document.addEventListener('turbo:before-cache', disposeBootstrapInteractives);

// LRPO-5251 — DataTables rebuilds the table DOM when it draws, which orphans
// any Bootstrap Popover bound to the markup it replaced. The ⓘ metric-explainer
// icons in DataTable headers then render but never open. Re-bind on DataTables'
// own draw event so this holds for EVERY DataTable — initial draw, pagination,
// sorting and searching alike — rather than patching one page at a time.
// initBootstrapInteractives() is idempotent (it skips elements that already
// have an instance), so re-running it is safe.
if (window.jQuery) {
  window.jQuery(document).on('draw.dt', initBootstrapInteractives);
}

// Chartkick + Turbo Frame init handling lives in the Reports Hub Stimulus
// controller (`app/frontend/stimulus/reports_page_controller.js`). Scoped
// there so it only fires for frame swaps inside the Reports Hub root,
// destroys stale Chart.js instances before re-init, and skips ES modules
// + scripts marked `data-turbo-eval="false"`. Keeping it out of this
// file's document-level listeners avoids re-executing unrelated inline
// scripts elsewhere in the app on every frame swap (114 turbo_frame_tag
// sites, 202 view files with inline <script> across admin/exhibitor).
//
// Chartkick + Turbo DRIVE lifecycle for every OTHER page (exhibitor/admin
// dashboards etc.) lives in javascript/chartkick_turbo_lifecycle.js: Turbo's
// follow-redirect ghost render (willRender:false) and history restorations
// fire Chartkick's global destroyAll without re-running the inline init
// scripts, leaving blank canvases. The bridge rebuilds only registry-orphaned
// charts on turbo:render and excludes `.reports-page` (owned above).
startChartkickTurboLifecycle();

$(document).on("turbo:load", function () {
  // Exclude tables with data-leads-ajax — they have their own serverSide+AJAX
  // DataTable init (e.g. app/views/exhibitor/leads/_table.html.erb). A default
  // no-AJAX init here would race with that and orphan the AJAX response in
  // DataTables 2.x. Keyed on a data attribute (not id) so other pages that
  // reuse id="table-leads" (Users index, Reps Import) still get generic init.
  if (!$.fn.DataTable.isDataTable("table[id^=table-]:not([data-leads-ajax])")) {
    $("table[id^=table]:not([data-leads-ajax])").DataTable();
  }
  if (!$.fn.DataTable.isDataTable("table[id^=admin_table-]")) {
    $("table[id^=admin_table]").each(function () {
      var table = $(this);
      var tableIdsToSkipLastColumn = ['admin_table-exhibitor', 'admin_table-attendee', 'admin_table-exhibitors', 'admin_table-activation'];
      var headersToSkip = ['Actions', 'Action', 'Select', 'Activated'];
      var tableName = table.attr('id').split('-')[1];

      table.DataTable({
        dom: '<"top d-flex justify-content-between"<"length-menu"l><"search-and-buttons d-flex"fB>>rt<"bottom d-flex justify-content-between"ip><"clear">',
        lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
        buttons: [
          {
            extend: 'excel',
            text: 'Export to Excel',
            title: '',
            filename: tableName + '_' + new Date().toISOString().slice(0, 10),
            exportOptions: {
              columns: function (index, data, node) {
                if (tableIdsToSkipLastColumn.includes(table.attr('id'))) {
                  var headerText = table.find('th').eq(index).text().trim();
                  return !headersToSkip.includes(headerText);
                }
                return true;
              }
            }
          }
        ]
      });
    });
  }
});

$(document).on("turbo:before-cache", function () {
  var dataTable = $($.fn.dataTable.tables(true)).DataTable();
  if (dataTable !== null) {
    // dataTable.clear();
    dataTable.destroy();
    return (dataTable = null);
  }
});
